import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { adoptPersonalKey } from './identity';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Layout } from './components/Layout';
import Pocketbase from './pages/Pocketbase';
import PollEntry from './pages/PollEntry';
import Poll from './pages/Poll';
import { PollProvider } from './components/PollContext';

function PersonalLink() {
  adoptPersonalKey(window.location.hash.slice(1));
  return <Navigate to="/" replace />;
}

function App() {
  return (
    <Router>
      <PollProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<PollEntry />} />
            <Route path="/about" element={<About />} />
            <Route path="/pocketbase" element={<Pocketbase />} />
            <Route path="/poll/:slug" element={<Poll />} />
            <Route path="/me" element={<PersonalLink />} />
          </Routes>
        </Layout>
      </PollProvider>
    </Router>
  );
}

export default App;
